<template>
  <div class="page">
    <div class="page-container">
      <project-page-header ref="pageHeader" :id="projectId">
        <template v-slot:actions>
          <a-space>
            <a-button class="v-px-sm" icon="left" size="small" type="default" @click="$router.push(`../view/basic?id=${projectId}`)">返回项目详情</a-button>
          </a-space>
        </template>
      </project-page-header>
      <div class="page-title">财务请款单</div>
      <div class="panel-body">
        <div class="w1000">
          <a-steps progress-dot class="v-mt-lg v-mb-md" size="small" :current="currentStep">
            <a-step title="提交请款单">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="record.state > 0">
                <div>{{ record.submitTime ? record.submitTime.substring(0, 16) : '' }}</div>
              </div>
            </a-step>
            <a-step title="项目官员审核" />
            <a-step title="项目主管审核" />
            <a-step title="财务审核" />
            <a-step title="负责人审核" />
            <a-step title="完成" />
          </a-steps>
        </div>
        <div class="w1000" v-if="record.checkResult == -1">
          <a-alert class="v-mb-sm no-border" type="error">
            <div slot="message">
              <div class="font-md text-darkblue flex items-center"><a-icon type="alert" class="v-mr-xs" />此财务请款单已被驳回</div>
              <div class="flex v-mt-xs">
                <span class="text-right text-grey">审核意见：</span>
                <span class="col text-red" v-html="$utils.convertToHtml(record.checkOpinion)"></span>
              </div>
            </div>
          </a-alert>
        </div>
        <div class="w1000">
          <div class="panel-info-section relative-position">
            <div class="panel-info-section-title">
              <a-icon type="caret-right" class="text-primary v-mr-xs" />
              <span class="text-bold">请款信息</span>
            </div>
            <table class="table table-plain">
              <tbody>
                <tr>
                  <th>实际请款金额</th>
                  <td><b class="text-indigo">{{ $utils.thousands(record.applyAmount) }}</b> 元</td>
                  <th>付款申请日期</th>
                  <td>{{ record.applyDate }}</td>
                </tr>
                <tr>
                  <th>捐赠物品和服务说明</th>
                  <td colspan="3">{{ record.serviceDesc }}</td>
                </tr>
                <tr>
                  <th>捐赠物品及服务公允值</th>
                  <td colspan="3">{{ $utils.thousands(record.serviceFairValue, 0) }}</td>
                </tr>
                <tr>
                  <th>收款单位</th>
                  <td colspan="3">{{ record.billTitle }}</td>
                </tr>
                <tr>
                  <th width="200">开户行</th>
                  <td width="32%">{{ record.bankName }}</td>
                  <th width="160">银行账号</th>
                  <td>{{ record.bankCard }}</td>
                </tr>
                <tr>
                  <th>捐赠凭证</th>
                  <td colspan="3">
                    <file-container :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01" v-if="record.files && projectId"></file-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="panel-info-section" v-if="[1, 2, 3, 4].includes(record.state)">
            <div class="panel-info-section-title">
              <a-icon type="caret-right" class="text-primary v-mr-xs" />
              <span class="text-bold">财务信息</span>
            </div>
            <table class="table table-plain">
              <tbody>
                <tr>
                  <th>项目预算金额</th>
                  <td colspan="3">{{ $utils.thousands(project.amount) }}</td>
                  <!-- <th>筹款金额</th> -->
                  <!-- <td>{{ $utils.thousands(project.raisedAmount) }}</td> -->
                </tr>
                <tr>
                  <th width="200">已请款金额</th>
                  <td width="32%">{{ $utils.thousands(project.appliedAmount) }}</td>
                  <th width="160">实际已支出金额</th>
                  <td>{{ $utils.thousands(project.expensedAmount) }}</td>
                </tr>
                <tr>
                  <th>本次请款金额</th>
                  <td>{{ $utils.thousands(record.applyAmount) }}</td>
                  <th>请款金额累计</th>
                  <td>{{ $utils.thousands(project.appliedAmount + (record.applyAmount || 0))}}</td>
                </tr>
                <tr>
                  <th>请款余额</th>
                  <td class="text-red">{{ $utils.thousands(project.appliedAmount + (record.applyAmount || 0) - project.expensedAmount) }}</td>
                  <th>差额</th>
                  <td>{{ $utils.thousands(project.amount - project.expensedAmount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="text-center v-mt-lg">
          <a-space>
            <template v-if="isProcessable(record.state)">
              <a-button icon="rollback" type="indigo" :loading="saving" @click="handleReviewBackConfirm">驳回</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-if="record.state == 1">审核通过，提交主管审核</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-else-if="record.state == 2">审核通过，提交财务审核</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-else-if="record.state == 3">审核通过，提交负责人审核</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-else-if="record.state == 4">审核通过</a-button>
            </template>
              <template v-if="hasPermission('project:house:applybill:delete') && (record.state == 0 || record.state == 9)">
                <a-button type="danger" :loading="saving" @click="handleRemove">
                  <i class="fa fa-trash-o v-mr-sm"></i>
                  删除
                </a-button>
              </template>
            <a-button icon="left" key="backward" @click="$router.go(-1)">返回</a-button>
          </a-space>
        </div>
      </div>
    </div>
    <a-modal centered title="驳回财务请款单" :visible="rejectModal" @cancel="cancelRejectModal" width="650px" :body-style="{ padding: '12px' }">
      <template slot="footer">
        <a-space>
          <a-button @click="cancelRejectModal">取消</a-button>
          <a-button class="v-px-sm" type="indigo" :loading="saving" @click="handleReview(false, 0)" v-if="[1, 2].includes(record.state)">确认驳回，退回至施工方</a-button>
          <a-button class="v-px-sm" type="indigo" :loading="saving" @click="handleReview(false, record.state - 1)" v-if="[2, 3, 4].includes(record.state)">确认驳回，退回至官员</a-button>
          <a-button class="v-px-sm" type="indigo" :loading="saving" @click="handleReview(false, record.state - 2)" v-if="[3, 4].includes(record.state)">确认驳回，退回至主管</a-button>
          <a-button class="v-px-sm" type="indigo" :loading="saving" @click="handleReview(false, record.state - 3)" v-if="[4].includes(record.state)">确认驳回，退回至财务</a-button>
        </a-space>
      </template>
      <a-textarea v-model="rejectReason" :rows="6" placeholder="输入驳回原因" ref="rejectReason" />
    </a-modal>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { getApplyBill, reviewApplyBill, delApplyBill } from '@/api/project/common'
export default {
  name: 'ProjectHouseApplyBill',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      applyId: this.$route.query.aid,
      loading: false,
      saving: false,
      record: {},
      currentStep: 0,
      rejectModal: false,
      rejectReason: '',
    }
  },
  computed: {
    project: vm => vm.$store.state.app.project,
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id, aid } = this.$route.query
      if (id) {
        this.projectId = +id
      }
      if (aid) {
        this.applyId = +aid
        this.loadApplyBill()
      }
    },
    loadApplyBill() {
      this.loading = true
      getApplyBill(this.applyId).then(({ data }) => {
        if (data.success) {
          this.record = data.result
          let { state } = data.result
          this.currentStep = state == 9 ? 5 : state
        }
        this.loading = false
      })
    },
    cancelRejectModal() {
      this.rejectModal = false
    },
    handleReviewBackConfirm() {
      this.rejectReason = ''
      this.rejectModal = true
    },
    handleConfirmReview() {
      this.$confirm({
        title: '确认审核通过？',
        centered: true,
        onOk: () => {
          this.handleReview(true)
        },
      })
    },
    handleReview(approved, backsteps = 0) {
      let { applyId, projectId, rejectReason } = this
      this.$message.destroy()
      if (!approved && rejectReason.trim() === '') {
        this.$message.warn('请输入驳回原因')
        this.$refs.rejectReason.focus()
        return
      }
      let params = {
        id: applyId,
        projectId,
        result: approved ? 1 : 0,
        backsteps,
        opinion: rejectReason.trim(),
      }
      this.saving = true
      reviewApplyBill(params)
        .then(({ data }) => {
          this.saving = false
          if (data.success) {
            this.$message.success('操作成功')
            this.$router.go(-1)
          } else {
            this.$message.warn(data.msg)
          }
        })
        .catch(() => {
          this.saving = false
          this.$message.warn('操作失败')
        })
    },
    handleRemove() {
      let { state } = this.record
      this.$confirm({
        title: '确认删除此财务请款单？',
        okText: '确认删除',
        content: state == 9 ? h => <div class="text-red font-13">已审核通过的请款单删除后，项目的已请款金额将会回滚。</div> : null,
        centered: true,
        onOk: () => {
          this.saving = true
          let { applyId, projectId } = this
          return new Promise((resolve, reject) => {
            delApplyBill(applyId, projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.$router.go(-1)
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
              this.saving = false
            })
          })
        },
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
